import React from 'react';
import RadioDualComponent from 'shared/components/RadioDualComponent';

const ClassThreeInspection = (props) => {
  const name = 'class_3_inspection';

  const {
    label,
    parameters,
    onChangeParameter,
    groupName,
    required,
    tooltip,
    className,
    disabled,
  } = props;

  const onChange = (e) => onChangeParameter(name, e.target.value);

  return (
    <RadioDualComponent
      name={name}
      label={label}
      tooltip={tooltip}
      onChange={onChange}
      parameters={parameters}
      className={className}
      disabled={disabled}
      required={required}
      groupName={groupName} />
  );
};

ClassThreeInspection.defaultProps = {
  inputId: 'class-3-inspection',
  label: Spree.translations.parameters.class_3_inspection,
  tooltip: Spree.helpForParameters.class_3_inspection,
};

export default ClassThreeInspection;
